import { createClassName } from 'utils/createClassName';

import './servicePageLayoutStyles.scss';

export const createServicePageLayoutClassName = createClassName(
  'servicePageLayout'
);
